<template>
  <scrollable-container
    id="printable"
    :class="$style.scrollableContainer"
  >
    <container :class="$style.scrollableContent">
      <div v-if="isTableGroupedByDates">
        <div
          v-for="date in filteredtableData"
          :key="date.date"
        >
          <div :class="$style.date">
            {{ formatDate(date.date) }}
          </div>
          <custom-table
            :departments="date.groups"
            :title="printers"
          />
        </div>
      </div>
      <div v-else>
        <custom-table
          :departments="filteredtableData"
          :title="printers"
        />
      </div>
    </container>
  </scrollable-container>
</template>

<script>
  import { formatDate } from '@/helpers/format-date';
  import ScrollableContainer from '@/components/common/blocks/scrollable-container.vue';
  import Container from '@/components/common/blocks/container.vue';
  import CustomTable from '@/components/common/table/printer-report-table.vue';
  import { getPrinterReport } from '@/api/methods/reports/printers/reports/index';

  export default {
    components: {
      ScrollableContainer,
      Container,
      CustomTable,
    },
    data() {
      return {
        name: this.$t('reports.printerReport'),
        printers: { title: this.$t('reports.printer'), element: 'employees' },
        tableDataGroupedByDates: [],
        tableDataGroupedByDepartments: [],
        columns: [
          { name: this.$t('reports.columns.employee'), sort: 0, field: 'name' },
          { name: this.$t('reports.columns.pageCount'), sort: 1, field: 'pages' },
          { name: this.$t('reports.columns.cost'), sort: 0, field: 'cost' },
        ],
      };
    },
    computed: {
      dateRange() {
        return this.$store.getters['filters/formattedDateRange'];
      },
      isTableGroupedByDates() {
        return this.$store.getters['filters/isTableGroupedByDates'];
      },
      filteredtableData() {
        const selectedOption = this.$store.getters['filters/printerSelectedOption'];
        if (this.isTableGroupedByDates) {
          if (selectedOption) {
            const result = [];
            for (let i = 0; i < this.tableDataGroupedByDates.length; i++) {
              const printers = this.tableDataGroupedByDates[i].groups.filter((printer) =>
                printer.name.includes(selectedOption),
              );
              if (printers && printers.length) {
                result.push({
                  date: this.tableDataGroupedByDates[i].date,
                  groups: printers,
                });
              }
            }
            return result;
          }

          return this.tableDataGroupedByDates;
        }
        if (selectedOption) {
          const result = [];
          for (let i = 0; i < this.tableDataGroupedByDepartments.length; i++) {
            const printers = this.tableDataGroupedByDepartments[i].groups.filter((printer) =>
              printer.name.includes(selectedOption),
            );
            if (printers && printers.length) {
              result.push({
                groups: printers,
              });
            }
          }
          return result;
        }
        return this.tableDataGroupedByDepartments;
      },
    },
    watch: {
      dateRange(oldValue, newValue) {
        if (
          oldValue.dateFrom.toString() !== newValue.dateFrom.toString() ||
          oldValue.dateTo.toString() !== newValue.dateTo.toString()
        ) {
          this.fetch();
        }
      },
    },
    created() {
      this.fetch();
    },
    methods: {
      fetch() {
        this.tableDataGroupedByDates = [];
        this.tableDataGroupedByDepartments = [];
        if (this.dateRange.dateFrom && this.dateRange.dateTo) {
          this.promise = getPrinterReport(this.dateRange.dateFrom, this.dateRange.dateTo).then(
            ({ groupedByDates, groupedByGroups }) => {
              this.tableDataGroupedByDates = groupedByDates;
              this.tableDataGroupedByDepartments = groupedByGroups;
              this.sendSelectOptions();

              const exportArray = [];
              groupedByGroups.forEach((printer) => {
                printer.employees.forEach((one) => {
                  const resObj = { Принтер: printer.name };
                  for (let j = 0; j < this.columns.length; j++) {
                    resObj[this.columns[j].name] = one[this.columns[j].field];
                  }
                  exportArray.push(resObj);
                });
              });

              this.$store.commit('exportData/setPrinterReport', { name: this.name, data: exportArray });

              return { groupedByDates, groupedByGroups };
            },
          );
        }
      },
      sendSelectOptions() {
        /* eslint-disable-next-line */
        const printerNameList = this.tableDataGroupedByDates.map((x) => x.groups.map((z) => z.name));
        /* eslint-disable-next-line */
        const concatList = [].concat.apply([], printerNameList);
        this.$store.commit(
          'filters/setPrinterOptions',
          /* eslint-disable-next-line */
          [].concat.apply([], concatList),
        );
      },
      formatDate(date) {
        return formatDate(date);
      },
    },
  };
</script>

<style lang="scss" module>
  .date {
    background-color: $light-gray;
    letter-spacing: -0.24px;
    width: 90px;
    height: 24px;
    font-family: inherit;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    padding: 5px 10px;
    font-feature-settings: 'tnum' on, 'lnum' on;
    display: flex;
    align-items: center;
    color: #4b4b4b;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: white;
  }

  ::-webkit-scrollbar-thumb {
    background: $branchColor;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: darkgray;
  }

  .scrollableContent {
    margin: 0 8px 0 0;
    padding: 0 12px 0 20px;
  }

  .scrollableContainer {
    padding-bottom: 20px;
  }
</style>
